module.exports = __webpack_public_path__ + "img/ManChilltWoEsGeht.06c9cc69.svg";